import { render, staticRenderFns } from "./TurnManualOverride.vue?vue&type=template&id=3b90255c&scoped=true"
import script from "./TurnManualOverride.vue?vue&type=script&lang=js"
export * from "./TurnManualOverride.vue?vue&type=script&lang=js"
import style0 from "./TurnManualOverride.vue?vue&type=style&index=0&id=3b90255c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b90255c",
  null
  
)

export default component.exports